import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../../hooks/hooks";
import { LoadingType } from "../../types";
import { doFetch } from "../../utils/doFetch";
import { updateElementValue } from "../../utils/updateElementValue";
import { updateElementObject } from "../../utils/updateElementObject";
import { RootState } from "../store";
import { showHideLoadingGif } from "./commonSlice";
import { getEcomplaintMainDetails,updateElementObjectValueComplaintMain } from "../slice/complaintMainSlice";
import { properties, LF_VOID_STATUS, LF_DELETED_STATUS, LF_RETURNED_STATUS, LF_REJECTED_STATUS, LF_SEND_TO_SA_STATUS, LF_SEND_TO_OFFICER_STATUS, FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE, LF_PENDING_STATUS, LF_STATUS_PENDING_SUPERVISOR_RETURNED, LF_STATUS_PENDING_SUPERVISOR_REVIEW,LF_COMPLAINT_ECFORM_IMAGE_UPLOAD_SUCCESS, PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE, LF_ARREST_WARRANT} from '../../constants/common';
import { setComplaintMainData } from "./complaintMainSlice";
import { fetchArrestWarrant } from "../../redux/slice/arrestWarrantSlice";
import { getLFCConcurrentObj } from "./commonFormSlice";
import { fetchSummons } from "../../redux/slice/summonsSlice";
import {reSubmitComplaint} from "../../services/EComplaintService";

interface complaintDashboardReducer {
    dashboardStatus: LoadingType;
    dashboardError?: string;
    successMessage?: string;
    failureMessage?: string;
    importFrom: string;
}

const initialState = {
  dashboardStatus: "idle",
  dashboardError: undefined,
  successMessage: "",
  failureMessage: "",
  importFrom: "",
} as complaintDashboardReducer;

export const editComplaint = createAsyncThunk<
  any,
  { formId:number, formType:string, ecomplaintId:number, status:any, actionType: string, formData?: any; navigate: any },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/editComplaint",
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { formId, formType, ecomplaintId, status, actionType, formData, navigate } = data;
    
    let { token } = getState().login;

    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);

    try {
      dispatch(showHideLoadingGif(true));
      const reponse = await doFetch({
        url: `ecomplaintservices/updateEcomplaint/${formId}/${formType}/${ecomplaintId}/${status}/${actionType}`,
        type: "PUT",
        token,
        body: formData?formData:{},
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch : dispatch
      });
      dispatch(showHideLoadingGif(false));
      if (reponse.ok) {
        reponse.json().then((result)=>{
          console.log(result.complaint);
          dispatch(updateElementObjectValueComplaintMain(result));
          dispatch(
            getEcomplaintMainDetails({
              ecomplaintId: ecomplaintId,
              callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
            })
          );
        })
        let message = "";
        if (status === LF_VOID_STATUS) {
            message = "The complaint has been void.";
        } else if (status === LF_DELETED_STATUS) {
            message = "The complaint has been deleted.";
        } else if (status === LF_RETURNED_STATUS || status === LF_STATUS_PENDING_SUPERVISOR_RETURNED) {
            message = "The complaint has been returned.";
            navigate("/eComplaintDashBoard");
        } else if (status === LF_REJECTED_STATUS) {
            message = "The complaint has been rejected.";
            navigate("/eComplaintDashBoard");
        } else if (status === LF_SEND_TO_SA_STATUS || status === LF_SEND_TO_OFFICER_STATUS) {
            navigate("/eComplaintDashBoard");
        } else if(status === LF_PENDING_STATUS){
          navigate("/eComplaintDashBoard");
        }
        
        if (message.trim().length > 0) {
          dispatch(
            updateElementValuecomplaintDashReducer({
              elementName: "successMessage",
              value: message,
            })
          );
        }
        
    } else {
        dispatch(
          updateElementValuecomplaintDashReducer({
            elementName: "failureMessage",
            value: "Error Occurred",
          })
        );
    }
    dispatch(showHideLoadingGif(false));
    } catch (error: any) {
      dispatch(showHideLoadingGif(false));
      dispatch(
        updateElementValuecomplaintDashReducer({
          elementName: "failureMessage",
          value: "Communication error occurred. Can not proceed now",
        })
      );
    }
    }
);


export const editComplaintFromSummons = createAsyncThunk<
  any,
  { formId:number, formType:string, ecomplaintId:number, status:any, actionType: string, formData?: any; navigate: any },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/editComplaintfromSummons",
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { formId, formType, ecomplaintId, status, actionType, formData, navigate } = data;
    
    let { token } = getState().login;

    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);

    try {
      dispatch(showHideLoadingGif(true));
      const reponse = await doFetch({
        url: `ecomplaintservices/updateEcomplaintFromSummons/${formId}/${formType}/${ecomplaintId}/${status}/${actionType}`,
        type: "PUT",
        token,
        body: formData?formData:{},
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch : dispatch
      });
      dispatch(showHideLoadingGif(false));
      if (reponse.ok) {
        reponse.json().then((result)=>{
          console.log(result.complaint);
          dispatch(updateElementObjectValueComplaintMain(result));
          dispatch(
            getEcomplaintMainDetails({
              ecomplaintId: ecomplaintId,
              callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
            })
          );
        })
        let message = "";
        if (status === LF_VOID_STATUS) {
            message = "The complaint has been void.";
        } else if (status === LF_DELETED_STATUS) {
            message = "The complaint has been deleted.";
        } else if (status === LF_RETURNED_STATUS || status === LF_STATUS_PENDING_SUPERVISOR_RETURNED) {
            message = "The complaint has been returned.";
            navigate("/eComplaintDashBoard");
        } else if (status === LF_REJECTED_STATUS) {
            message = "The complaint has been rejected.";
            navigate("/eComplaintDashBoard");
        } else if (status === LF_SEND_TO_SA_STATUS || status === LF_SEND_TO_OFFICER_STATUS) {
            navigate("/eComplaintDashBoard");
        } else if(status === LF_PENDING_STATUS){
          navigate("/eComplaintDashBoard");
        }
        
        if (message.trim().length > 0) {
          dispatch(
            updateElementValuecomplaintDashReducer({
              elementName: "successMessage",
              value: message,
            })
          );
        }
        
    } else {
        dispatch(
          updateElementValuecomplaintDashReducer({
            elementName: "failureMessage",
            value: "Error Occurred",
          })
        );
    }
    dispatch(showHideLoadingGif(false));
    } catch (error: any) {
      dispatch(showHideLoadingGif(false));
      dispatch(
        updateElementValuecomplaintDashReducer({
          elementName: "failureMessage",
          value: "Communication error occurred. Can not proceed now",
        })
      );
    }
    }
);

export const resubmitComplaint = createAsyncThunk<
  any,
  {
    _ecCaseDetail: any;
    fromScheduler: boolean;
    navigate: any
  },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/resubmitComplaint",
  async ({ _ecCaseDetail, fromScheduler, navigate }, { getState, dispatch, rejectWithValue }) => {
    let { token } = getState().login;
    dispatch(showHideLoadingGif(true));
    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);
    try {
      const response =await reSubmitComplaint({token, _ecCaseDetail, fromScheduler, concurrentObj, dispatch});
      if (response.ok) {
        dispatch(showHideLoadingGif(false));
        const result = await response.json();
          dispatch(setComplaintMainData(result));
          // navigate("/EComplaintDashboard");
          if(result?.complaint !== null && !result?.complaint.commFailed && result?.messageList.length === 0) {
         return {status: "success", message: "Complaint has been resubmitted successfully."};
        }else{
              return rejectWithValue("Failed to resubmit the complaint. Please try again shortly.");
            }
      } else {
        dispatch(showHideLoadingGif(false));
        // const error = await response.json();
        return rejectWithValue("Failed to resubmit the complaint. Please try again shortly.");
      }
    } catch (error: any) {
        dispatch(showHideLoadingGif(false));
        return rejectWithValue("Failed to resubmit the complaint. Please try again shortly.");
    }
  }
);


export const resubmitAccordingToTheFormType = createAsyncThunk<
  any,
  { ecomplaintId: number, fromScheduler: boolean , formType: string,formId: number },
  { state: RootState; rejectValue: string }
>("ecomplaint/resubmitAccordingToTheFormType",
  async ({ecomplaintId,fromScheduler,formType,formId}, { getState, dispatch,rejectWithValue }) => {

    let { token } = getState().login;

    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);

    try {
      dispatch(showHideLoadingGif(true));
      const response = await doFetch({
        url: `ecomplaintservices/reSubmitForm/${formId}/${fromScheduler}/${formType}`,
        type: "POST",
        token,
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch: dispatch
      });
      dispatch(showHideLoadingGif(false));
      if (response.ok) {
        const responseData = await response.json();
        if (responseData) {
          dispatch(
            getEcomplaintMainDetails({
              ecomplaintId: ecomplaintId,
              callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
            })
          );
          const imageUploadStatus= responseData.ecFormList?.find(
            (ecForm: any) => ecForm.formId === formId && ecForm.imageUploadStatus === LF_COMPLAINT_ECFORM_IMAGE_UPLOAD_SUCCESS
          );
          if(imageUploadStatus && (responseData.messageList==null || responseData.messageList.length === 0)){
            return {status: "success", message: `${formType} form resubmission completed successfully.`};
          }else{
            return rejectWithValue(`Failed to resubmit the ${formType}. Please try again shortly.`);
          }
        }else{
          return rejectWithValue(`Failed to resubmit the ${formType}. Please try again shortly.`);
        }
      } else {
          return rejectWithValue(`Failed to resubmit the ${formType}. Please try again shortly.`)
      }
    } catch (error: any) {
          dispatch(showHideLoadingGif(false));
          return rejectWithValue(`Failed to resubmit the ${formType}. Please try again shortly.`);
    }
  }
)

export const deleteForms = createAsyncThunk<
  any,
  { formId:number, formType:string, ecomplaintId:number, status:string, clickCancel?: any, navigate?: any },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/deleteForms",
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { formId, formType, ecomplaintId, status, clickCancel = false, navigate } = data;
    let { token } = getState().login;

    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);
    try {
      dispatch(showHideLoadingGif(true));
      const reponse = await doFetch({
        url: `ecomplaintservices/deleteEcForms/${formId}/${ecomplaintId}`,
        type: "PUT",
        token,
        body: JSON.stringify({}),
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch : dispatch
      });
      dispatch(showHideLoadingGif(false));
      if (reponse.ok) {
        reponse.json().then((result)=>{
          console.log(result);
          dispatch(updateElementObjectValueComplaintMain(result));
          dispatch(
            getEcomplaintMainDetails({
              ecomplaintId: ecomplaintId,
              callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
            })
          );
        })
        //KHL PR 11814 09/01/2025 START
        let message = "";
        if (formType == PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE){
          if (!clickCancel){
              message = "The PreTrial Release on Own Recognizance has been deleted.";
          }
              navigate("/EComplaintDashboard");
        } else if(formType == LF_ARREST_WARRANT){
              message = "The Arrest Warrant has been deleted.";
        }
        //KHL PR 11814 09/01/2025 END
        if (message.trim().length > 0) {
            dispatch(
              updateElementValuecomplaintDashReducer({
                elementName: "successMessage",
                value: message,
              })
            );
        }
        
    } else {
        dispatch(
          updateElementValuecomplaintDashReducer({
            elementName: "failureMessage",
            value: "Error Occurred",
          })
        );
    }
    dispatch(showHideLoadingGif(false));
    } catch (error: any) {
      dispatch(showHideLoadingGif(false));
      dispatch(
        updateElementValuecomplaintDashReducer({
          elementName: "failureMessage",
          value: "Communication error occurred. Can not proceed now",
        })
      );
    }
    }
);

export const updateLockById = createAsyncThunk<
  any,
  { formId:number, ecomplaintId:number, action:string },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/deleteArrestWarrant",
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { formId, ecomplaintId, action } = data;
    let { token } = getState().login;

    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);

    try {
      dispatch(showHideLoadingGif(true));
      // dispatch(getEcomplaintMainDetails())
      const reponse = await doFetch({
        url: `ecomplaintservices/updateLockById/${formId}/${ecomplaintId}/${action}`,
        type: "PUT",
        token,
        body: JSON.stringify({}),
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch : dispatch
      });
      dispatch(showHideLoadingGif(false));
      if (reponse.ok) {
        reponse.json().then((result)=>{
          console.log(result);
          dispatch(updateElementObjectValueComplaintMain(result));
          dispatch(
            getEcomplaintMainDetails({
              ecomplaintId: ecomplaintId,
              callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
            })
          );
        })
        
    } else {
      // dispatch(fetchEComplaintMainFailed("Error Occurred"));
    }
    dispatch(showHideLoadingGif(false));
    } catch (error: any) {
      dispatch(showHideLoadingGif(false));
        console.log(error);
    }
    }
);

export const undoCertification = createAsyncThunk<
  any,
  { complaintId: number },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/undoCertification",
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { complaintId } = data;
    let { token } = getState().login;

    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);

    try {
      dispatch(showHideLoadingGif(true));
      const reponse = await doFetch({
        url: `ecomplaintservices/undoCertification/${complaintId}`,
        type: "POST",
        token,
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch : dispatch        
      });

      dispatch(showHideLoadingGif(false));
      if (reponse.ok) {
        dispatch(
          getEcomplaintMainDetails({
            ecomplaintId: complaintId,
            callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
          })
        );
        return reponse.json();
      }
      return rejectWithValue("Error while making undo Certification");
    } catch (error) {
      dispatch(showHideLoadingGif(false));
      return rejectWithValue("Error while making undo Certification");
    }
  }
);

export const takeComplaintBack = createAsyncThunk<
  any,
  { complaintId: number; objUse: any; navigate: any },
  { state: RootState; rejectValue: string }
>(
  "ecomplaint/takeComplaintBack",
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { complaintId, objUse, navigate } = data;
    let { token } = getState().login;
    let ecList = getState().complaintMain.ecFormList;
    let concurrentObj = getLFCConcurrentObj(ecList);
    try {
      dispatch(showHideLoadingGif(true));
      const reponse = await doFetch({
        url: `ecomplaintservices/takeComplaintBack/${complaintId}`,
        type: "POST",
        token,
        concurrentObject: concurrentObj,
        concurrentIdentifier: "LFC",
        dispatch : dispatch
      });

      dispatch(showHideLoadingGif(false));
      if (reponse.ok) {
        reponse.json().then((result)=>{
          dispatch(setComplaintMainData(result));
          // dispatch(
          //   getEcomplaintMainDetails({
          //     ecomplaintId: complaintId,
          //     callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE,
          //   })
          // );
          // dispatch(updateElementObjectValueComplaintMain(result));
        dispatch(getEcomplaintMainDetails({ecomplaintId: complaintId, callingFrom: FETCH_LF_MAIN_DETAILS_FROM_MAIN_PAGE}));
        if ("Complaint" === objUse.formType) {
          navigate("/eComplaintMainPage");
        } else if ("Arrest Warrant" === objUse.formType) {
          // dispatch(setECFormData(objUse.formId, result.ecForm.status));
          dispatch(
            fetchArrestWarrant(objUse.formId)
          ).then((res) => {
            if (res){
              navigate("/arrestWarrant");
            }
          })
        } else if ("Summon" === objUse.formType) {
          dispatch(
            fetchSummons(objUse.formId)
          ).then((res) => {
            if (res){
              navigate("/issueSummons");
            }
          })
        }
      }
      )}
    } catch (error: any) {
      dispatch(showHideLoadingGif(false));
      return rejectWithValue(
        error.message || "Error while fetching agencies for LFC county"
      );
    }
  }
);

const complaintDashSlice = createSlice({
  name: "editComplaint",
  initialState,
  reducers: {
    updateElementValuecomplaintDashReducer: updateElementValue,
    // updateElementObjectValueComplaintDash: (state: complaintDashboardReducer, action) => {
    //   updateElementObject(state, action, state.complaint);
    // },
  },
  extraReducers(builder) {
    builder

    .addCase(editComplaint.pending, (state) => {
      state.dashboardStatus = "loading";
      state.dashboardError = undefined;
    })
    .addCase(editComplaint.fulfilled, (state, action) => {
      state.dashboardStatus = "success";
      // state.complaint = action.payload.complaint;
    })
    .addCase(editComplaint.rejected, (state, action) => {
      state.dashboardStatus = "error";
      state.dashboardError = undefined;
    })
    .addCase(editComplaintFromSummons.pending, (state) => {
      state.dashboardStatus = "loading";
      state.dashboardError = undefined;
    })
    .addCase(editComplaintFromSummons.fulfilled, (state, action) => {
      state.dashboardStatus = "success";
      // state.complaint = action.payload.complaint;
    })
    .addCase(editComplaintFromSummons.rejected, (state, action) => {
      state.dashboardStatus = "error";
      state.dashboardError = undefined;
    })
    .addCase(resubmitAccordingToTheFormType.pending,(state) => {
      state.dashboardStatus = "loading";
      state.dashboardError = undefined;
    })
    .addCase(resubmitAccordingToTheFormType.fulfilled,(state,action) => {
        state.dashboardStatus = "success";
        state.failureMessage = undefined;
        state.dashboardError = undefined;
        state.successMessage = action.payload.message;
    })
    .addCase(resubmitAccordingToTheFormType.rejected,(state,action) => {
      state.dashboardStatus = "error";
      state.successMessage= undefined;
      state.dashboardError = action.payload || "Unable to complete the request. Please try again shortly.";
      state.failureMessage = action.payload || "Unable to complete the request. Please try again shortly."; 
    })
    .addCase(resubmitComplaint.pending,(state) => {
      state.dashboardStatus = "loading";
      state.dashboardError = undefined;
    })
    .addCase(resubmitComplaint.fulfilled,(state,action) => {
        state.dashboardStatus = "success";
        state.dashboardError = undefined;
        state.successMessage = action.payload.message;
    })
    .addCase(resubmitComplaint.rejected,(state,action) => {
      state.dashboardStatus = "error";
      state.successMessage= undefined;
      state.dashboardError = action.payload ||"Unable to complete the request. Please try again shortly.";
      state.failureMessage = action.payload ||"Unable to complete the request. Please try again shortly."; 
    })
  

    .addCase(deleteForms.pending, (state) => {
      state.dashboardStatus = "loading";
      state.dashboardError = undefined;
    })
    .addCase(deleteForms.fulfilled, (state, action) => {
      state.dashboardStatus = "success";
    })
    .addCase(deleteForms.rejected, (state, action) => {
      state.dashboardStatus = "error";
      state.dashboardError = undefined;
    })

    .addCase(undoCertification.pending, (state) => {
      state.dashboardStatus = "loading";
      state.dashboardError = undefined;
    })
    .addCase(undoCertification.fulfilled, (state, action) => {
      state.dashboardStatus = "success";
      // state.complaint = action.payload.complaint;
    })
    .addCase(undoCertification.rejected, (state, action) => {
      state.dashboardStatus = "error";
      state.dashboardError = undefined;
    })
  },
});

export const { updateElementValuecomplaintDashReducer } = complaintDashSlice.actions;

export const useComplaintDashReducer = () => useAppSelector((state) => state.complaintDashboard);

export default complaintDashSlice.reducer;
